angular.module("tromanWeb").controller('AwardEditController', ['$q', 'DialogControllerBase', '$scope', 'tromanServer', 'award', function ($q, DialogControllerBase, $scope, tromanServer, award) {

    var self = this;
    DialogControllerBase.call(self, tromanServer.Awards, $scope);

    self.getTitle = function () { return '"' + self.award.Name + '"'; };
    self.getItem = function () { return self.award; };

    function load() {
        self.loadItem(award)
            .then(loadRelated)
            .then(loaded)
            .catch(self.showError);
    }

    function loaded(data) {
        angular.extend(self, data);
    }

    function loadRelated(loadedAward) {
        return $q.all({
            award: $q.when(loadedAward)
        });
    }

    load();

}]);
